/**
 * Keys for persistent store
 */
export const RECENTLY_PLAYED_KEY = 'RECENTLY_PLAYED';
export const GAME_OF_THE_DAY_KEY = 'GAME_OF_THE_DAY';
export const HOROSCOPE_LIST_KEY = 'HOROSCOPE_DATA';
export const USER_SELECTED_ZODIAC_KEY = 'USER_SELECTED_ZODIAC';
export const WELCOME_BANNER_SHOWN_KEY = 'WELCOME_BANNER_SHOWN';
export const SESSION_COUNT_KEY = 'SESSION_COUNT';
export const WEATHER_DATA_KEY = 'WEATHER_DATA';
export const TF_ACCOUNT_LINK = 'TF_ACCOUNT_LINK';
export const USER_PREFERENCE = 'USER_PREFERENCE';
export const CHILD_DIRECTED_TREATMENT = 'CHILD_DIRECTED_TREATMENT';
export const AGE_GATING_AGE_GROUP = 'AGE_GATING_AGE_GROUP';

/**
 * Configurations for persistent store
 */
export const RECENTLY_PLAYED_MAX_COUNT = 4;
